import { Component, ContentChild, input, linkedSignal, output } from '@angular/core';

import { XiPopoutContentDirective } from 'app/directives/xi-popout-content.directive';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-xi-popout',
  templateUrl: './lex-xi-popout.component.html',
  styleUrls: ['./lex-xi-popout.component.css'],
  standalone: false,
})
export class LexXiPopoutComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  readonly isVisible = input<boolean>();
  readonly element = input<HTMLElement>();
  readonly internalPadding = input<number>();
  readonly containedPopoutIds = input<string[]>([]);
  containedPopoutIdsSignal = linkedSignal({
    source: this.containedPopoutIds,
    computation: (ids) => (!ids.includes(this.KXI_XI_POPOUT) ? [...ids, this.KXI_XI_POPOUT] : ids),
  });
  readonly close = output<void>();

  @ContentChild(XiPopoutContentDirective) content: XiPopoutContentDirective;

  readonly KXI_XI_POPOUT = 'kxi-xi-popout';

  onClose(): void {
    this.close.emit();
  }
}
